// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class EventQuestion_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.EventQuestion';
  $t: string = 'SagaSchema.EventQuestion';

  public static GetMembers(): string[] {
    return ['EventID', 'QuestionUID', 'SortOrder', 'Question', 'UIControlType'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return EventQuestion_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public EventID: number = 0;
  public QuestionUID: Guid = GuidTools.Empty;
  public SortOrder: number = 0;
  public Question: string;
  public UIControlType: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.QuestionUID;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
